export default __webpack_public_path__ + "static/media/Grupo1894.673d6763.png";